'use client';

import { matchPath } from 'react-router';

import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import { embedSearchWidgetPrefix } from '#/modules/embedSearchWidget/routing/embedSearchWidget.paths';

export function getEmbedSearchWidgetIdFromPathname(
  pathname: string,
): ApiEmbedSearchWidgetId | undefined {
  const match = matchPath(embedSearchWidgetPrefix.wrapperPath, pathname);
  if (!match) return;

  return match.params.embedSearchWidgetId;
}
